<template>
<div v-if="ready">
    <fieldset v-if="debug">
        <legend>Rules</legend>
        <div style="float:left; margin: 5px; border: 1px dashed teal; padding: 8px;">
            <h3>USER</h3>
            <ul>
                <li :class="{[$style.outcome_true]:state===true}" v-for="(state,index) in user.assessment.debug.severity" :key="'cat_'+index">{{index}}: {{state}}</li>
            </ul>
            <hr>
            Severity: {{user.assessment.severity}}<br>
            State: {{user.assessment.state}}
        </div>

        <div style="float:left; margin: 5px; border: 1px dashed teal; padding: 8px;">
            <h3>FACULTY</h3>
            <ul>
                <li :class="{[$style.outcome_true]:state===true}" v-for="(state,index) in faculty.assessment.debug.severity" :key="'cat_'+index">{{index}}: {{state}}</li>
            </ul>
            <hr>
            Severity: {{faculty.assessment.severity}}<br>
            State: {{faculty.assessment.state}}
        </div>

        <div style="float:left; margin: 5px; border: 1px dashed teal; padding: 8px;">
            <h3>GUIDELINES</h3>
            <ul>
                <li :class="{[$style.outcome_true]:state===true}" v-for="(state,index) in guidelines.assessment.debug.severity" :key="'cat_'+index">{{index}}: {{state}}</li>
            </ul>
            <hr>
            Severity: {{guidelines.assessment.severity}}<br>
            State: {{app.state}}
            <hr>
            {{app.state}} | <v-btn @click="reset">Reset</v-btn>
        </div>
        
        <hr style="clear:both;">
        
    </fieldset>

    <center>
        <v-btn
            :class="$style.button" 
            v-if="toggle_faculty_badge===true && click_continue===false"  
            @click="click_continue=true;continueSurvey()">{{$language()=='fr' ? "CLIQUER ICI - MISE EN PRATIQUE DES RECOMMANDATIONS POUR LA MPOC" : "Click Here To Apply Recommendations in COPD"}}</v-btn>
    </center>

    <table :class="$style.table" v-if="click_continue">
        <thead>
            <tr>
                <th colspan='1'>
                    <div style="position: relative;">
                        <badge :badgeType="'user'" style="position: absolute; top: -5px; left: 20%; transform: translateX(-20%);"/> 
                        <span>{{$language()=='fr' ? "Votre évaluation" : "Your Assessment"}}</span>
                    </div>
                    <!-- <badge :badgeType="'faculty'"/> <span>{{$language()=='fr' ? "Évaluation des lignes directrices de la directives SCT" : "CTS Guidelines Assessment"}}</span> -->
                </th>

                <th colspan='1'>
                    <div style="position: relative;">
                        <badge :badgeType="'faculty'" style="position: absolute; top: -5px; left: 10%; transform: translateX(-10%);"/> 
                        <span style="margin-left: 15%;" v-if="$language()=='fr'">{{"Évaluation des lignes directrices de la directives SCT"}}</span>
                        <span v-else>{{"CTS Guidelines Assessment"}}</span>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th>
                    <div :class="[$style.severity]">
                        {{$language()=='fr' ? 'Légère' : 'Mild'}}
                    </div>
                </th>
                <th colspan='2'>
                    <div :class="[$style.severity]">
                        {{$language()=='fr' ? 'Modérée à grave' : 'Moderate to Severe'}}
                    </div>
                </th>
            </tr>

            <tr>
                <td></td>
                <td>
                    <guideline_box :label="user.labels.moderate.risk" :severity="'moderate'" :state="1" :id="'severity'"/>
                    
                </td>
                <td>
                    <guideline_box :label="user.labels.severe.risk" :severity="'severe'" :state="1" :id="'severity'"/>
                </td>
            </tr>

            <tr>
                <td>
                    <guideline_box :userBadge="user.assessment.severity=='mild' && user.assessment.state==2" :facultyBadge="show_faculty_badge('mild',2)" :label="user.labels.mild.controlled" :severity="'mild'" :state="2"/>
                </td>
                <td>
                    <guideline_box :userBadge="user.assessment.severity=='moderate' && user.assessment.state==2" :facultyBadge="show_faculty_badge('moderate',2)" :label="user.labels.moderate.controlled" :severity="'moderate'" :state="2"/>
                </td>
                <td>
                    <guideline_box :userBadge="user.assessment.severity=='severe' && user.assessment.state==2" :facultyBadge="show_faculty_badge('severe',2)" :label="user.labels.severe.controlled" :severity="'severe'" :state="2"/>
                </td>
            </tr>

            <tr>
                <td>
                    <guideline_box :userBadge="user.assessment.severity=='mild' && user.assessment.state==3" :facultyBadge="show_faculty_badge('mild',3)" :label="user.labels.mild.step_up" :severity="'mild'" :state="3"/>
                </td>
                <td>
                    <guideline_box :userBadge="user.assessment.severity=='moderate' && user.assessment.state==3" :facultyBadge="show_faculty_badge('moderate',3)" :label="user.labels.moderate.step_up" :severity="'moderate'" :state="3"/>
                </td>
                <td>
                    <guideline_box :userBadge="user.assessment.severity=='severe' && user.assessment.state==3" :facultyBadge="show_faculty_badge('severe',3)" :label="user.labels.severe.step_up" :severity="'severe'" :state="3"/>
                </td>
            </tr>

            <tr>
                <td/>
                <td>
                    <guideline_box :userBadge="user.assessment.severity=='moderate' && user.assessment.state==4" :facultyBadge="show_faculty_badge('moderate',4)" :label="user.labels.moderate.step_down" :severity="'moderate'" :state="4"/>
                </td>
                <td/>
            </tr>
        </tbody>
    </table>

    <center>
        <v-btn :class="$style.button" v-if="toggle_faculty_badge===false" @click="toggle_faculty_badge=!toggle_faculty_badge">{{$language()=='fr' ? "Suivant – Mise en pratique des recommandations pour la MPOC avec ce patient" : "Next—Apply Recommendations in COPD to This Patient"}}</v-btn>
        <!-- <v-btn :class="$style.button" v-if="toggle_faculty_badge===true && click_continue===false"  @click="click_continue=true;continueSurvey()">{{$language()=='fr' ? "Mise en pratique des recommandations pour la MPOC" : "Apply Recommendations in COPD"}}</v-btn> -->
    </center>
    
    <div v-if="click_continue">
        <guideline_lungFunction :debug="debug" :app="app" :assessment="guidelines.assessment" :questionMap="questionMap"/>
        <reminder :selections="questionMap[8].value[1]"/>
    </div>
    
</div>
</template>

<script>
import { Machine, interpret, assign, sendParent, spawn, raise, actions, send, respond} from 'xstate';
import reminder from './lib/reminder.vue';
import guideline_box from './lib/guideline_box.vue';
import guideline_lungFunction from './lib/guideline_lungFunction.vue';
import badge from './lib/assets/badge.vue';

export default {
    props: {
        question: {
            type: Object,
            required: true
        },
        questionMap: {
            type: Object,
            required: true
        },
        debug: {
            type: Boolean,
            required: true
        }
    },
    components: {
        reminder,
        guideline_box,
        guideline_lungFunction,
        badge
    },
    created: function(){
        var self = this;
        const mild = {
            initial: 'q15',
            id: 'mild',
            states: {
                q15: {
                    on: {
                        q15_1: 'OUTCOME_2',
                        q15_2: 'OUTCOME_1',
                        q15_3: 'OUTCOME_1',
                        q15_4: 'OUTCOME_1',
                        q15_5: 'OUTCOME_1',
                        q15_6: 'OUTCOME_1',
                        q15_7: 'OUTCOME_1',
                        q15_8: 'OUTCOME_2'
                    }
                },
                OUTCOME_1: {type: 'final'},
                OUTCOME_2: {type: 'final'}
            }
        }

        const moderate = {
            initial: 'q15',
            id: 'moderate',
            states: {
                q15: {
                    on: {
                        q15_1: '#moderate.OUTCOME_5',
                        q15_2: 'q18_A',
                        q15_3: 'q18_A',
                        q15_4: 'q18_A',
                        q15_5: '#moderate.OUTCOME_4',
                        q15_6: '#moderate.OUTCOME_5',
                        q15_7: 'q18_B',
                        q15_8: '#moderate.OUTCOME_5'
                    },
                },                
                q18_A: {
                    initial: 'q18',
                    states: {
                        q18: {
                            on: {
                                q18_1: '#moderate.OUTCOME_3',
                                q18_2: '#moderate.OUTCOME_5'
                            },
                        }
                    }
                },
                q18_B: {
                    initial: 'q18',
                    states: {
                        q18: {
                            on: {
                                q18_1: 'q13',
                                q18_2: '#moderate.OUTCOME_6'
                            }
                        },
                        q13: {
                            initial: 'q13',
                            states: {
                                q13: {
                                    on: {
                                        q13_1: 'q14',
                                        q13_2: 'q14',
                                        q13_3: '#moderate.OUTCOME_7'
                                    }
                                },
                                q14: {
                                    initial: 'q14',
                                    states: {
                                        q14: {
                                            on: {
                                                q14_1: '#moderate.OUTCOME_7',
                                                q14_2: '#moderate.OUTCOME_7',
                                                q14_3: 'q17'
                                            }
                                        },
                                        q17: {
                                            initial: 'q17',
                                            states: {
                                                q17: {
                                                    on: {
                                                        q17_1: '#moderate.OUTCOME_7',
                                                        q17_2: '#moderate.OUTCOME_3',
                                                        q17_3: '#moderate.OUTCOME_3'
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }                        

                    }
                },
                OUTCOME_3: {type: 'final'},
                OUTCOME_4: {type: 'final'},
                OUTCOME_5: {type: 'final'},
                OUTCOME_6: {type: 'final'},
                OUTCOME_7: {type: 'final'},
            }
        }

        const severe = {
            initial: 'q15',
            id: 'severe',
            states: {
                q15: {
                    on: {
                        q15_1: '#severe.OUTCOME_10',
                        q15_2: '#severe.OUTCOME_10',
                        q15_3: '#severe.OUTCOME_10',
                        q15_4: 'q20',
                        q15_5: 'q13',
                        q15_6: '#severe.OUTCOME_10',
                        q15_8: '#severe.OUTCOME_10',
                        q15_7: 'q20'
                    }
                },
                q20: {
                    on: {
                        q20_1: 'q18',
                        q20_2: 'q21',
                        q20_3: 'q21'
                    }
                },
                q18: {
                    on: {
                        q18_1: '#severe.OUTCOME_8',
                        q18_2: '#severe.OUTCOME_10'
                    }
                },
                q21: {
                    on: {
                        q21_1: 'q18',
                        q21_2: '#severe.OUTCOME_10'
                    }
                },
                q13: {
                    initial: 'q13',
                    states: {
                        q13: {
                            on: {
                                q13_1: 'q14',
                                q13_2: 'q14',
                                q13_3: '#severe.OUTCOME_9'
                            }
                        },
                        q14: {
                            initial: 'q14',
                            states: {
                                q14: {
                                    on: {
                                        q14_1: '#severe.OUTCOME_9',
                                        q14_2: '#severe.OUTCOME_9',
                                        q14_3: '#severe.q20'
                                    }
                                }
                            }
                        }
                    }
                },
                OUTCOME_8: {type: 'final'},
                OUTCOME_9: {type: 'final'},
                OUTCOME_10: {type: 'final'},
            }
        }
    

        let machineConfig = {
            id: 'severity',
            initial: 'mild_moderate_severe',
            states: {
                mild_moderate_severe: {
                    initial: 'q19',
                    states: {
                        q19: {
                            on: {
                                q19_1: 'q20',
                                q19_2: 'q20',
                                q19_3: '#severity.severe'
                            }
                        },
                        q20: {
                            on: {
                                q20_1: '#severity.mild_moderate',
                                q20_2: '#severity.severe',
                                q20_3: '#severity.severe'
                            }
                        },
                    }
                },
                mild_moderate: {
                    type: 'parallel',
                    states: {
                        q10: {
                            id: 'q10',
                            initial: 'q10',
                            states: {
                                q10: {
                                    on: {
                                        q10_1: '#severity.mild',
                                        q10_2: '#severity.moderate'
                                    }
                                }
                            }
                        },
                        q11: {
                            id: 'q11',
                            initial: 'q11',
                            states: {
                                q11: {
                                    on: {
                                        q11_1: '#severity.mild',
                                        q11_2: '#severity.moderate'
                                    }
                                }
                            }
                        },
                        q12: {
                            id: 'q12',
                            initial: 'q12',
                            states: {
                                q12: {
                                    on: {
                                        q12_1: '#severity.mild',
                                        q12_2: '#severity.mild',
                                        q12_3: '#severity.moderate',
                                        q12_4: '#severity.moderate',
                                        q12_5: '#severity.moderate'
                                    }
                                }
                            }
                        }
                    }
                },
                mild: mild,
                moderate: moderate,
                severe: severe
            }
        }
        const machine = Machine(machineConfig);
        this.machine = machine;

        this.initialize();
        
        setTimeout(function(){
            self.ready = true;
        },0);
    },
    data: function(){
        return {
            ready: false,
            machine: null,
            app: null,            
            click_continue: false,
            toggle_faculty_badge: true,
            tableLabels: {
                mild: {
                    controlled: {
                        user: {
                            en: "Controlled symptoms",
                            fr: "Symptômes maîtrisés"
                        },
                        faculty: {
                            en: "Controlled",
                            fr: "Maîtrisée"
                        }
                    },
                    step_up: {
                        user: {
                            en: "Possible candidate for step-up",
                            fr: "Candidat possible pour l’escalade"
                        },
                        faculty: {
                            en: "Possible candidate for step-up",
                            fr: "Candidat possible pour l’escalade"
                        }
                    }
                },
                moderate: {
                    risk: {
                        user: {
                            en: "Low risk for acute exacerbations",
                            fr: "Faible risque d’exacerbations aiguës"
                        },
                        faculty: {
                            en: "Low risk for acute exacerbations",
                            fr: "Faible risque d’exacerbations aiguës"
                        }
                    },
                    controlled: {
                        user: {
                            en: "Controlled symptoms",
                            fr: "Symptômes maîtrisés"
                        },
                        faculty: {
                            en: "Controlled, explore appropriate treatment options",
                            fr: "Maîtrisée"
                        }
                    },
                    step_up: {
                        user: {
                            en: "Possible candidate for step-up",
                            fr: "Candidat possible pour l’escalade"
                        },
                        faculty: {
                            en: "Possible candidate for step-up",
                            fr: "Candidat possible pour l’escalade"
                        }
                    },
                    step_down: {
                        user: {
                            en: "Possible candidate for step-down",
                            fr: "Candidat possible pour la désescalade"
                        },
                        faculty: {
                            en: "Possible candidate for step-down",
                            fr: "Candidat possible pour la désescalade"
                        }
                    }
                },
                severe: {
                    risk: {
                        user: {
                            en: "High risk for acute exacerbations",
                            fr: "Risque élevé d’exacerbations aiguës"
                        },
                        faculty: {
                            en: "High risk for acute exacerbations",
                            fr: "Risque élevé d’exacerbations aiguës"
                        }
                    },
                    controlled: {
                        user: {
                            en: "Controlled symptoms",
                            fr: "Symptômes maîtrisés"
                        },
                        faculty: {
                            en: "Controlled",
                            fr: "Maîtrisée"
                        }
                    },
                    step_up: {
                        user: {
                            en: "Possible candidate for step-up",
                            fr: "Candidat possible pour l’escalade"
                        },
                        faculty: {
                            en: "Possible candidate for step-up",
                            fr: "Candidat possible pour l’escalade"
                        }
                    }
                }
            }
        }
    },
    methods: {
        initialize: function(){
            var machine = this.machine;
            var app = {
                service: interpret(machine),
                state: machine.initialState,
            }

            app.service.onTransition(state => {
                app.state = state.value;
            }).start();
            this.app = app;
        },
        reset: function(){
            this.app.service.stop();
            this.initialize();            
        },        
        testBox: function(data){
            this[data.type].assign.severity(data.severity, data.state)
        },
        continueSurvey: function(){
            var questionMap = this.questionMap;
            var unhideThese = [22,23,24,25];
            for(let i=0; i<unhideThese.length; i++){
                var qid = unhideThese[i];
                var question = questionMap[qid];
                if(question.display_triggers.length==0){
                    question.display = true;
                }
            }
            this.$emit('widgetRequest',{
                request: function(survey){
                    survey.enableSubmit = true
                }
            })
        },
        show_faculty_badge: function(severity, state){
            var match = this.guidelines.assessment.severity == severity && this.guidelines.assessment.state==state;
            return this.toggle_faculty_badge && match;
        }
    },
    computed: {
        user: function(){
            let self = this;
            let q3 = this.questionMap[3];
            let q5 = this.questionMap[5];
            let q6 = this.questionMap[6];

            let assessment = getAssessment();
            function getAssessment(){
                let isMild = q3.value[1]!=null && !isModerate && !isSevere;
                let isModerate = q5.value[1]!=null && !isMild && !isSevere;
                let isSevere = q6.value[1]!=null && !isMild && !isModerate;
                

                function getSeverity(){
                    let severity = null;
                    if(isMild){severity = 'mild'}
                    if(isModerate){severity = 'moderate'}
                    if(isSevere){severity = 'severe'}
                    return severity;
                }

                
                function getState(){
                    let severity = getSeverity();
                    var state = 1;
                    switch(severity){
                        case"mild":
                            var source = q3.value[1];
                            if(self.$root.in_array(source,[1])){state = 2}
                            if(self.$root.in_array(source,[2])){state = 3}
                            return state;
                        break;

                        case"moderate":
                            var source = q5.value[1];
                            if(self.$root.in_array(source,[1])){state = 2}
                            if(self.$root.in_array(source,[2])){state = 3}
                            if(self.$root.in_array(source,[3])){state = 4}
                            return state;
                        break;

                        case"severe":
                            var source = q6.value[1];
                            if(self.$root.in_array(source,[1])){state = 2}
                            if(self.$root.in_array(source,[2])){state = 3}
                            return state;
                        break;
                    }
                }

                return {
                    severity: getSeverity(),
                    state: getState(),
                    debug: {
                        sources: {
                            q3: q3.value[1],
                            q5: q5.value[1],
                            q6: q6.value[1],
                        },
                        severity: {
                            isMild: isMild,
                            isModerate: isModerate,
                            isSevere: isSevere
                        }
                    }
                }
            }



            let assign = new function(){
                function getRandomInt(min, max) {
                    min = Math.ceil(min);
                    max = Math.floor(max);
                    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
                }

                this.severity = function(severity , state=null){

                    switch(severity){
                        case"mild":
                            self.questionMap[2].controller.setValue(1,1);

                            if(state===null){
                                var value = getRandomInt(2,3);
                            }else{
                                switch(state){
                                    case 2:case 3:
                                        var value = state-1;
                                    break;
                                }
                            }
                            q3.controller.setValue(1,value);
                        break;

                        case"moderate":
                            self.questionMap[2].controller.setValue(1,2);
                            self.questionMap[4].controller.setValue(1,1);

                            if(state===null){
                                var value = getRandomInt(1,3);
                            }else{
                                var value = state-1;
                            }
                            q5.controller.setValue(1,value);
                        break;

                        case"severe":
                            self.questionMap[2].controller.setValue(1,2);
                            self.questionMap[4].controller.setValue(1,2);
                            
                            if(state===null){
                                q5.controller.random();
                            }else{
                                var value = [];
                                value.push(state-1);
                            }
                            q6.controller.setValue(1,value);
                        break;
                    }
                }

            }       

            return {
                assign: assign,
                labels: {
                    mild: {
                        controlled: this.tableLabels.mild.controlled.user[this.$language()],
                        step_up: this.tableLabels.mild.step_up.user[this.$language()],
                    },
                    moderate: {
                        risk: this.tableLabels.moderate.risk.user[this.$language()],
                        controlled: this.tableLabels.moderate.controlled.user[this.$language()],
                        step_up: this.tableLabels.moderate.step_up.user[this.$language()],
                        step_down: this.tableLabels.moderate.step_down.user[this.$language()],
                    },
                    severe: {
                        risk: this.tableLabels.severe.risk.user[this.$language()],
                        controlled: this.tableLabels.severe.controlled.user[this.$language()],
                        step_up: this.tableLabels.severe.step_up.user[this.$language()],
                    }
                },
                assessment: assessment
            }
        },
        faculty: function(){
            
            let self = this;
            let q10 = this.questionMap[10];
            let q11 = this.questionMap[11];
            let q12 = this.questionMap[12];
            let q13 = this.questionMap[13];
            let q14 = this.questionMap[14];
            let q15 = this.questionMap[15];
            let q17 = this.questionMap[17];
            let q18 = this.questionMap[18];
            let q19 = this.questionMap[19];
            let q20 = this.questionMap[20];

            let assessment = getAssessment();
            function getAssessment(){
                let isMild = (self.$root.in_array(q10.value[1],[1]) || self.$root.in_array(q11.value[1],[1]) || self.$root.in_array(q12.value[1],[1,2])) && !isModerate && !isSevere;
                let isModerate = (self.$root.in_array(q10.value[1],[2]) || self.$root.in_array(q11.value[1],[2]) || self.$root.in_array(q12.value[1],[3,4,5])) && (self.$root.in_array(q19.value[1],[1,2]) && self.$root.in_array(q20.value[1],[1])) && !isMild && !isSevere;
                let isSevere = (self.$root.in_array(q10.value[1],[2]) || self.$root.in_array(q11.value[1],[2]) || self.$root.in_array(q12.value[1],[3,4,5])) && (self.$root.in_array(q19.value[1],[3]) || self.$root.in_array(q20.value[1],[2,3])) && !isMild && !isModerate;
                

                function getSeverity(){
                    let severity = null;
                    if(isMild){severity = 'mild'}
                    if(isModerate){severity = 'moderate'}
                    if(isSevere){severity = 'severe'}
                    return severity;
                }

                
                function getState(){
                    let severity = getSeverity();
                    var state = 1;
                    switch(severity){
                        case"mild":
                            var states = {
                                2: {
                                    18: self.$root.in_array(q18.value[1], [1]),
                                    19: self.$root.in_array(q19.value[1], [1]),
                                    20: self.$root.in_array(q20.value[1], [1]),
                                    15: self.$root.in_array(q15.value[1], [2,3])
                                },
                                3: {
                                    18: self.$root.in_array(q18.value[1], [1,2]),
                                    19: self.$root.in_array(q19.value[1], [1]),
                                    20: self.$root.in_array(q20.value[1], [1]),
                                    15: self.$root.in_array(q15.value[1], [1])
                                }
                            }
                            if(self.$root.allTrue(states[2])){state = 2}
                            if(self.$root.allTrue(states[3])){state = 3}
                            return state;
                        break;

                        case"moderate":
                            var states = {
                                2: {
                                    18: self.$root.in_array(q18.value[1], [1]),
                                    '(15:[2,3,4,5]) || (15:[5,7] && 14:[2,3])': self.$root.in_array(q15.value[1], [2,3,4,5]) || (self.$root.in_array(q15.value[1], [5,7]) && self.$root.in_array(q14.value[1], [2,3]))
                                },
                                3: {
                                    '19:[1,2] && 20:[1]': self.$root.in_array(q19.value[1], [1,2]) && self.$root.in_array(q20.value[1], [1]),
                                    13: self.$root.in_array(q13.value[1], [1,2,3,4,6]),
                                    14: self.$root.in_array(q14.value[1], [2])
                                },
                                4: {
                                    18: self.$root.in_array(q18.value[1], [1]),
                                    '15:[5,7] && 14:[1] && 17:[1]': self.$root.in_array(q19.value[1], [1,2]) && self.$root.in_array(q14.value[1], [1]) && self.$root.in_array(q17.value[1], [1]),
                                }
                            }
                            if(self.$root.allTrue(states[2])){state = 2}
                            if(self.$root.allTrue(states[3])){state = 3}
                            if(self.$root.allTrue(states[4])){state = 4}
                            return state;
                        break;

                        case"severe":
                            var states = {
                                2: {
                                    '(15:[4,5] && 18:[1]) || (14:[2,3] && 15:[7])': ( self.$root.in_array(q15.value[1], [4,5]) && self.$root.in_array(q18.value[1], [1]) ) || ( (self.$root.in_array(q15.value[1], [7]) && self.$root.in_array(q18.value[1], [2])) || (self.$root.in_array(q14.value[1], [2,3]) && self.$root.in_array(q15.value[1], [7])) )
                                },
                                3: {
                                    '(15:[4,7] && 18:[2]) || 15:[1,2,3,6,8]': ( self.$root.in_array(q15.value[1], [4,7]) && self.$root.in_array(q18.value[1], [2]) ) || ( (self.$root.in_array(q15.value[1], [7]) && self.$root.in_array(q18.value[1], [2])) || (self.$root.in_array(q14.value[1], [2,3]) && self.$root.in_array(q15.value[1], [1,2,3,6,8])) )
                                }
                            }
                            if(self.$root.allTrue(states[2])){state = 2}
                            if(self.$root.allTrue(states[3])){state = 3}
                            return state;
                        break;
                    }
                }

                return {
                    severity: getSeverity(),
                    state: getState(),
                    debug: {
                        sources: {
                            q10: q10,
                            q11: q11,
                            q12: q12,
                            q14: q14,
                            q15: q15,
                            q17: q17,
                            q18: q18,
                            q19: q19,
                            q20: q20,
                        },
                        severity: {
                            isMild: isMild,
                            isModerate: isModerate,
                            isSevere: isSevere
                        }
                    }
                }
            }

            return {
                labels: {
                    mild: {
                        controlled: this.tableLabels.mild.controlled.faculty[this.$language()],
                        step_up: this.tableLabels.mild.step_up.faculty[this.$language()],
                    },
                    moderate: {
                        risk: this.tableLabels.moderate.risk.faculty[this.$language()],
                        controlled: this.tableLabels.moderate.controlled.faculty[this.$language()],
                        step_up: this.tableLabels.moderate.step_up.faculty[this.$language()],
                        step_down: this.tableLabels.moderate.step_down.faculty[this.$language()],
                    },
                    severe: {
                        risk: this.tableLabels.severe.risk.faculty[this.$language()],
                        controlled: this.tableLabels.severe.controlled.faculty[this.$language()],
                        step_up: this.tableLabels.severe.step_up.faculty[this.$language()],
                    }
                },
                assessment: assessment
            }
            
        },
        guidelines: function(){
            let self = this;
            let assessment = getAssessment();




            function getAssessment(){
                var in_array = self.$root.in_array;
                self.reset();
                
                sendValue(19);
                sendValue(20);

                

                if(self.app.state.mild_moderate){
                    sendValue(10);
                    sendValue(11);
                    sendValue(12);
                }
                
                if(self.app.state.mild){
                    sendValue(15);
                }
                
                if(self.app.state.moderate){
                    sendValue(15);
                    sendValue(18);
                    sendValue(13);
                    sendValue(14);
                    sendValue(17);
                }
                
                if(self.app.state.severe){
                    sendValue(15);
                    sendValue(20);
                    sendValue(21);
                    sendValue(18);
                    sendValue(13);
                    sendValue(14);
                }

                function sendValue(qid){
                    if(self.questionMap[qid].value[1]!=null){
                        var value = 'q'+qid+'_'+self.questionMap[qid].value[1].toString();
                        self.app.service.send(value);
                    }
                }


                let isMild = self.app.state.mild ? true : false;
                let isModerate = self.app.state.moderate ? true : false;
                let isSevere = self.app.state.severe ? true : false;
                

                function getSeverity(){
                    let severity = null;
                    if(isMild){severity = 'mild'}
                    if(isModerate){severity = 'moderate'}
                    if(isSevere){severity = 'severe'}
                    return severity;
                }

                
                function getState(){
                    let severity = getSeverity();
                    var state = 1;
                    switch(severity){
                        case"mild":
                            switch(self.app.state.mild){
                                case"OUTCOME_1":
                                    state = 2;
                                break;
                                case"OUTCOME_2":
                                    state = 3;
                                break;
                            }
                        break;

                        case"moderate":
                            switch(self.app.state.moderate){
                                case"OUTCOME_3":
                                    state = 2;
                                break;
                                case"OUTCOME_4":case"OUTCOME_5": case"OUTCOME_6":
                                    state = 3;
                                break;
                                case"OUTCOME_7":
                                    state = 4;
                                break;
                            }
                        break;

                        case"severe":
                            switch(self.app.state.severe){
                                case"OUTCOME_8":case"OUTCOME_9":
                                    state = 2;
                                break;
                                case"OUTCOME_10":
                                    state = 3;
                                break;
                            }
                            return state;
                        break;
                    }
                    return state;
                }

                return {
                    severity: getSeverity(),
                    state: getState(),
                    debug: {
                        severity: {
                            isMild: isMild,
                            isModerate: isModerate,
                            isSevere: isSevere
                        }
                    }
                }
            }

            return {
                labels: {
                    mild: {
                        controlled: this.tableLabels.mild.controlled.user[this.$language()],
                        step_up: this.tableLabels.mild.step_up.user[this.$language()],
                    },
                    moderate: {
                        risk: this.tableLabels.moderate.risk.user[this.$language()],
                        controlled: this.tableLabels.moderate.controlled.user[this.$language()],
                        step_up: this.tableLabels.moderate.step_up.user[this.$language()],
                        step_down: this.tableLabels.moderate.step_down.user[this.$language()],
                    },
                    severe: {
                        risk: this.tableLabels.severe.risk.user[this.$language()],
                        controlled: this.tableLabels.severe.controlled.user[this.$language()],
                        step_up: this.tableLabels.severe.step_up.user[this.$language()],
                    }
                },
                assessment: assessment
            }
        }
    }
}
</script>

<style module>
.outcome_true{
    font-weight: bold;
    color: darkgreen;
}


.panel{
    float: left;
    width: 48%;
    min-height: 400px;
    border: 1px solid orange;
    border-radius: 3px;
}

.severity{
    position: relative;
    color: white;
    font-weight: 300;
    width: 90%;
    border-radius: 5px;
    padding: 3px;
    /* height: 50px; */
    background-color: #66ACDA;
    font-size: 21px;
    margin: 0 auto;
}



.table{
    margin: 0 auto;
    width: 100%;
    max-width: 1000px;
}

.table thead tr th {
    height: 60px;
}

.table td{
    width: 33%;
}

.button{
    background-color: #3bacc4 !important;
    color: white !important;
    font-weight: bold;
    border-radius: 15px;
    width: 170px auto;
    height: 80px;
    margin: 25px;
}
</style>